<template>
  <div>
    <h2
      v-if="
        strapiEventListPageGetters.getHorizontalCardListTitle(eventListPage)
      "
      class="text-h3 text-left font-semibold leading-7 mb-8"
    >
      {{ strapiEventListPageGetters.getHorizontalCardListTitle(eventListPage) }}
    </h2>

    <HorizontalScrollWrapper :items-length="cardList.length" class="gap-4 mb-5">
      <NuxtLinkLocale
        v-for="item in cardList"
        :key="item.title"
        :to="`${item.link}`"
        class="group transition-all hover:scale-[103%]"
      >
        <TransactionalPageCardListItem v-bind="item" />
      </NuxtLinkLocale>
    </HorizontalScrollWrapper>

    <a
      :href="
        strapiEventListPageGetters.getHorizontalCardListLink(eventListPage)
      "
      class="text-sm hover:text-primary"
      >{{
        strapiEventListPageGetters.getHorizontalCardListLinkText(eventListPage)
      }}
    </a>
  </div>
</template>

<script setup lang="ts">
import { type StrapiEventListPage } from '~/composables/types/strapiEventListPage'

const { eventListPage } = defineProps<{
  eventListPage: StrapiEventListPage
}>()

const route = useRoute()

const cardList = useState<
  {
    title: string
    subtitle: string
    imageUrl: string | undefined
    link: string
  }[]
>(`transactional-page-strapi-horizontal-list-${route.fullPath}`, () => [])

const fnMountStrapiHorizontalList = () => {
  const horizontalListArr =
    strapiEventListPageGetters.getHorizontalCardList(eventListPage)

  cardList.value = horizontalListArr.map((x) => ({
    title: x.title,
    subtitle: x.subtitle,
    imageUrl: strapiImageGetters.getImageUrl(x.image.data) || '',
    link: x.link,
  }))
}

if (cardList.value.length === 0) {
  fnMountStrapiHorizontalList()
}
</script>
